export default __webpack_public_path__ + "static/media/audioProductError.7c8aca3a.mp3";